import dayjs from 'dayjs';

type TaskOverdueFields = {
  date: string;
  time?: string | null;
  datetime?: string | null;
  isFinished?: boolean | null;
  result?: string | null;
};

export function hasTaskTime(time?: string | null) {
  return Boolean(time);
}

export function isTaskFinished(task: TaskOverdueFields) {
  return Boolean(task.isFinished || task.result);
}

export function isTaskOverdue(
  task: TaskOverdueFields,
  now = new Date(),
): boolean {
  if (isTaskFinished(task)) {
    return false;
  }

  if (hasTaskTime(task.time)) {
    return Boolean(task.datetime && new Date(task.datetime) < now);
  }

  return dayjs(task.date).startOf('day').isBefore(dayjs(now).startOf('day'));
}

export function getExpiredTasksFilter(now = new Date()) {
  const today = dayjs(now).format('YYYY-MM-DD');

  return {
    isFinished: { _eq: false },
    _or: [
      {
        _and: [
          { time: { _isNull: false } },
          { time: { _neq: '' } },
          { datetime: { _lt: now.toISOString() } },
        ],
      },
      {
        _and: [
          {
            _or: [{ time: { _isNull: true } }, { time: { _eq: '' } }],
          },
          { date: { _lt: today } },
        ],
      },
    ],
  };
}
